import { render, staticRenderFns } from "./AdminLogs.vue?vue&type=template&id=06ea6aa2&scoped=true"
import script from "./AdminLogs.vue?vue&type=script&lang=js"
export * from "./AdminLogs.vue?vue&type=script&lang=js"
import style0 from "./AdminLogs.vue?vue&type=style&index=0&id=06ea6aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea6aa2",
  null
  
)

export default component.exports